<script>
    import { createEventDispatcher } from "svelte";
    import { factoryStore } from "../store/factories.js";
    import { inputVariableStore } from "../store/inputVariables.js";
    import InputPercent from "./InputPercent.svelte";
    import InputMoney from "./InputMoney.svelte";
    import { outputVariableStore } from "../store/outputVariables.js";
    const dispatch = createEventDispatcher();
    export let variable;
    export let value;
    export let readonly;
    let timer;
    function bubbleDebounced(type) {
        clearTimeout(timer);
        timer = setTimeout(async () => {
            bubble(type);
        }, 50);
    }

    function bubble(type) {
        try {
            dispatch(type);
        } catch (s) {}
    }
    function isEdit(variable) {
        var theRealVar = $factoryStore.currentCalculator.variables.find(
            (v) => v.varNameKey == variable.nameKey
        );
        if (!theRealVar) return true;
        if (theRealVar.isFunction || theRealVar.readOnly) return false;
        return true;
    }
</script>

{#if variable}
    {#if variable.dataType == "int" || variable.dataType == "double" || variable.dataType == null || variable.varNameKey.toLowerCase() == "wage"}
        <input
            type="number"
            on:keyup={() => {
                bubbleDebounced("keyup");
            }}
            on:keydown={() => {
                bubbleDebounced("keydown");
            }}
            on:change={() => {
                bubble("change");
            }}
            on:focusout={() => {
                bubble("focusout");
            }}
            on:focusin={() => {
                bubble("focusin");
            }}
            varname={variable.nameKey}
            id={"inputfield-input-scenario-" + variable.nameKey}
            bind:value
            class:readonly={readonly || !isEdit(variable)}
            readonly={readonly || !isEdit(variable)}
        />
    {:else if variable && variable.dataType == "percent"}
        <InputPercent
            on:keyup={() => {
                bubble("keyup");
            }}
            on:keydown={() => {
                bubble("keydown");
            }}
            on:change={() => {
                bubble("change");
            }}
            on:focusout={() => {
                bubble("focusout");
            }}
            on:focusin={() => {
                bubble("focusin");
            }}
            id={"inputfield-input-scenario" + variable.nameKey}
            bind:value
            readonly={readonly || !isEdit(variable)}
        />
    {:else if variable.dataType == "currency"}
        <InputMoney
            on:keyup={() => {
                bubble("keyup");
            }}
            on:keydown={() => {
                bubble("keydown");
            }}
            on:change={() => {
                bubble("change");
            }}
            on:focusout={() => {
                bubble("focusout");
            }}
            on:focusin={() => {
                bubble("focusin");
            }}
            alternateCurrencyId={$factoryStore.currentCalculator
                .alternateCurrencyId}
            alternateCurrencyRate={$inputVariableStore.alternateCurrencyRate}
            mainCurrencyId={$factoryStore.currentCalculator.currencyId}
            id={"inputfield-input-scenario" + variable.nameKey}
            bind:value
            readonly={readonly || !isEdit(variable)}
        />
    {:else}
        NOT USED YET! For Text fields
        <input
            type="text"
            on:keyup={() => {
                bubbleDebounced("keyup");
            }}
            on:keydown={() => {
                bubbleDebounced("keydown");
            }}
            on:change={() => {
                bubble("change");
            }}
            on:focusout={() => {
                bubble("focusout");
            }}
            on:focusin={() => {
                bubble("focusin");
            }}
            varname={variable.nameKey}
            id={"inputfield-input-scenario" + variable.nameKey}
            bind:value
            class:readonly={readonly || !isEdit(variable)}
            disabled={readonly || !isEdit(variable)}
        />
    {/if}
{/if}
